import { create } from 'zustand';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/india`;

export const useIndiaDocsStore = create((set) => ({
  documents: [],
  groupedDocuments: {},
  transcripts: [],
  bseNotices: [],
  bseNoticesGrouped: {},
  ingestionStatus: null,
  universeRefreshStatus: null,
  loadingDocuments: false,
  loadingTranscripts: false,
  loadingBseNotices: false,
  loadingIngestionStatus: false,

  fetchDocuments: async (isin) => {
    if (!isin) return;
    set({ loadingDocuments: true });
    try {
      const { data } = await axios.get(`${API}/docs/all/${encodeURIComponent(isin)}`);
      set({
        documents: data.documents || [],
        groupedDocuments: data.grouped || {},
      });
    } catch (err) {
      console.error('Failed to fetch documents:', err);
      set({ documents: [], groupedDocuments: {} });
    } finally {
      set({ loadingDocuments: false });
    }
  },

  fetchEarningsTranscripts: async (isin) => {
    if (!isin) return;
    set({ loadingTranscripts: true });
    try {
      const { data } = await axios.get(`${API}/docs/earnings/${encodeURIComponent(isin)}`);
      set({ transcripts: data.transcripts || [] });
    } catch (err) {
      console.error('Failed to fetch earnings transcripts:', err);
      set({ transcripts: [] });
    } finally {
      set({ loadingTranscripts: false });
    }
  },

  fetchBseNotices: async (isin) => {
    if (!isin) return;
    set({ loadingBseNotices: true });
    try {
      const { data } = await axios.get(`${API}/docs/bse-notices/${encodeURIComponent(isin)}`);
      set({
        bseNotices: data.notices || [],
        bseNoticesGrouped: data.grouped || {},
      });
    } catch (err) {
      console.error('Failed to fetch BSE notices:', err);
      set({ bseNotices: [], bseNoticesGrouped: {} });
    } finally {
      set({ loadingBseNotices: false });
    }
  },

  fetchIngestionStatus: async () => {
    set({ loadingIngestionStatus: true });
    try {
      const { data } = await axios.get(`${API}/ingestion/status`);
      set({ ingestionStatus: data });
    } catch (err) {
      console.error('Failed to fetch ingestion status:', err);
      set({ ingestionStatus: null });
    } finally {
      set({ loadingIngestionStatus: false });
    }
  },

  startIngestion: async (isins = null) => {
    const body = {
      job_types: ['BSE_FILINGS', 'NSE_FILINGS', 'EARNINGS_TRANSCRIPTS', 'BSE_NOTICES'],
      isins,
      auto_start_workers: true,
    };
    return axios.post(`${API}/ingestion/start`, body);
  },

  triggerUniverseRefresh: async (runClassify = false, runEnrich = false) => {
    return axios.post(`${API}/ingestion/universe-refresh`, {
      run_classify: runClassify,
      run_enrich: runEnrich,
    });
  },

  fetchUniverseRefreshStatus: async () => {
    try {
      const { data } = await axios.get(`${API}/ingestion/universe-refresh/status`);
      set({ universeRefreshStatus: data });
    } catch (err) {
      console.error('Failed to fetch universe refresh status:', err);
      set({ universeRefreshStatus: null });
    }
  },
}));
